import { render } from "./TrainValSplitSlider.vue?vue&type=template&id=0e8bcadb"
import script from "./TrainValSplitSlider.vue?vue&type=script&lang=js"
export * from "./TrainValSplitSlider.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__